import {
    // CONTACT
    CORE_LOAD_ALL_CONTACT_REQUEST,
    CORE_LOAD_ALL_CONTACT_SUCCESS,
    CORE_LOAD_ALL_CONTACT_FAILURE,

    CORE_LOAD_CONTACT_REQUEST,
    CORE_LOAD_CONTACT_SUCCESS,
    CORE_LOAD_CONTACT_FAILURE,

    CORE_DELETE_CONTACT_REQUEST,
    CORE_DELETE_CONTACT_SUCCESS,
    CORE_DELETE_CONTACT_FAILURE,

    CORE_CREATE_CONTACT_REQUEST,
    CORE_CREATE_CONTACT_SUCCESS,
    CORE_CREATE_CONTACT_FAILURE,

    CORE_UPDATE_CONTACT_REQUEST,
    CORE_UPDATE_CONTACT_SUCCESS,
    CORE_UPDATE_CONTACT_FAILURE,

    //CUSTOMER
    CORE_LOAD_ALL_CUSTOMER_REQUEST,
    CORE_LOAD_ALL_CUSTOMER_SUCCESS,
    CORE_LOAD_ALL_CUSTOMER_FAILURE,

    CORE_LOAD_CUSTOMER_REQUEST,
    CORE_LOAD_CUSTOMER_SUCCESS,
    CORE_LOAD_CUSTOMER_FAILURE,

    CORE_DELETE_CUSTOMER_REQUEST,
    CORE_DELETE_CUSTOMER_SUCCESS,
    CORE_DELETE_CUSTOMER_FAILURE,

    CORE_CREATE_CUSTOMER_REQUEST,
    CORE_CREATE_CUSTOMER_SUCCESS,
    CORE_CREATE_CUSTOMER_FAILURE,

    CORE_UPDATE_CUSTOMER_REQUEST,
    CORE_UPDATE_CUSTOMER_SUCCESS,
    CORE_UPDATE_CUSTOMER_FAILURE,

    //DEVICE
    CORE_LOAD_ALL_DEVICE_REQUEST,
    CORE_LOAD_ALL_DEVICE_SUCCESS,
    CORE_LOAD_ALL_DEVICE_FAILURE,

    CORE_LOAD_DEVICE_REQUEST,
    CORE_LOAD_DEVICE_SUCCESS,
    CORE_LOAD_DEVICE_FAILURE,

    CORE_DELETE_DEVICE_REQUEST,
    CORE_DELETE_DEVICE_SUCCESS,
    CORE_DELETE_DEVICE_FAILURE,

    CORE_CREATE_DEVICE_REQUEST,
    CORE_CREATE_DEVICE_SUCCESS,
    CORE_CREATE_DEVICE_FAILURE,

    CORE_UPDATE_DEVICE_REQUEST,
    CORE_UPDATE_DEVICE_SUCCESS,
    CORE_UPDATE_DEVICE_FAILURE,

    //IOTACCESSORY
    CORE_LOAD_ALL_IOTACCESSORY_REQUEST,
    CORE_LOAD_ALL_IOTACCESSORY_SUCCESS,
    CORE_LOAD_ALL_IOTACCESSORY_FAILURE,

    CORE_LOAD_IOTACCESSORY_REQUEST,
    CORE_LOAD_IOTACCESSORY_SUCCESS,
    CORE_LOAD_IOTACCESSORY_FAILURE,

    CORE_DELETE_IOTACCESSORY_REQUEST,
    CORE_DELETE_IOTACCESSORY_SUCCESS,
    CORE_DELETE_IOTACCESSORY_FAILURE,

    CORE_CREATE_IOTACCESSORY_REQUEST,
    CORE_CREATE_IOTACCESSORY_SUCCESS,
    CORE_CREATE_IOTACCESSORY_FAILURE,

    CORE_UPDATE_IOTACCESSORY_REQUEST,
    CORE_UPDATE_IOTACCESSORY_SUCCESS,
    CORE_UPDATE_IOTACCESSORY_FAILURE,

    //IOTROOM
    CORE_LOAD_ALL_IOTROOM_REQUEST,
    CORE_LOAD_ALL_IOTROOM_SUCCESS,
    CORE_LOAD_ALL_IOTROOM_FAILURE,

    CORE_LOAD_IOTROOM_REQUEST,
    CORE_LOAD_IOTROOM_SUCCESS,
    CORE_LOAD_IOTROOM_FAILURE,

    CORE_DELETE_IOTROOM_REQUEST,
    CORE_DELETE_IOTROOM_SUCCESS,
    CORE_DELETE_IOTROOM_FAILURE,

    CORE_CREATE_IOTROOM_REQUEST,
    CORE_CREATE_IOTROOM_SUCCESS,
    CORE_CREATE_IOTROOM_FAILURE,

    CORE_UPDATE_IOTROOM_REQUEST,
    CORE_UPDATE_IOTROOM_SUCCESS,
    CORE_UPDATE_IOTROOM_FAILURE,

    CORE_UNREGISTER_IOTROOM_LICENSE_REQUEST,
    CORE_UNREGISTER_IOTROOM_LICENSE_SUCCESS,
    CORE_UNREGISTER_IOTROOM_LICENSE_FAILURE,

    //LICENSE
    CORE_LOAD_ALL_LICENSE_REQUEST,
    CORE_LOAD_ALL_LICENSE_SUCCESS,
    CORE_LOAD_ALL_LICENSE_FAILURE,

    CORE_LOAD_ALL_LICENSE_DISPLAY_REQUEST,
    CORE_LOAD_ALL_LICENSE_DISPLAY_SUCCESS,
    CORE_LOAD_ALL_LICENSE_DISPLAY_FAILURE,

    CORE_LOAD_ALL_LICENSE_IOT_REQUEST,
    CORE_LOAD_ALL_LICENSE_IOT_SUCCESS,
    CORE_LOAD_ALL_LICENSE_IOT_FAILURE,

    CORE_LOAD_LICENSE_REQUEST,
    CORE_LOAD_LICENSE_SUCCESS,
    CORE_LOAD_LICENSE_FAILURE,

    CORE_DELETE_LICENSE_REQUEST,
    CORE_DELETE_LICENSE_SUCCESS,
    CORE_DELETE_LICENSE_FAILURE,

    CORE_CREATE_LICENSE_REQUEST,
    CORE_CREATE_LICENSE_SUCCESS,
    CORE_CREATE_LICENSE_FAILURE,

    CORE_UPDATE_LICENSE_REQUEST,
    CORE_UPDATE_LICENSE_SUCCESS,
    CORE_UPDATE_LICENSE_FAILURE,

    //LICENSETYPE
    CORE_LOAD_ALL_LICENSETYPE_REQUEST,
    CORE_LOAD_ALL_LICENSETYPE_SUCCESS,
    CORE_LOAD_ALL_LICENSETYPE_FAILURE,

    CORE_LOAD_LICENSETYPE_REQUEST,
    CORE_LOAD_LICENSETYPE_SUCCESS,
    CORE_LOAD_LICENSETYPE_FAILURE,

    //PRODUCT
    CORE_LOAD_ALL_PRODUCT_REQUEST,
    CORE_LOAD_ALL_PRODUCT_SUCCESS,
    CORE_LOAD_ALL_PRODUCT_FAILURE,

    CORE_LOAD_PRODUCT_REQUEST,
    CORE_LOAD_PRODUCT_SUCCESS,
    CORE_LOAD_PRODUCT_FAILURE,

    CORE_DELETE_PRODUCT_REQUEST,
    CORE_DELETE_PRODUCT_SUCCESS,
    CORE_DELETE_PRODUCT_FAILURE,

    CORE_CREATE_PRODUCT_REQUEST,
    CORE_CREATE_PRODUCT_SUCCESS,
    CORE_CREATE_PRODUCT_FAILURE,

    CORE_UPDATE_PRODUCT_REQUEST,
    CORE_UPDATE_PRODUCT_SUCCESS,
    CORE_UPDATE_PRODUCT_FAILURE,

    CORE_UPVERSION_PRODUCT_REQUEST,
    CORE_UPVERSION_PRODUCT_SUCCESS,
    CORE_UPVERSION_PRODUCT_FAILURE,

    //PROFILE
    CORE_LOAD_ALL_PROFILE_REQUEST,
    CORE_LOAD_ALL_PROFILE_SUCCESS,
    CORE_LOAD_ALL_PROFILE_FAILURE,

    CORE_LOAD_PROFILE_REQUEST,
    CORE_LOAD_PROFILE_SUCCESS,
    CORE_LOAD_PROFILE_FAILURE,

    CORE_DELETE_PROFILE_REQUEST,
    CORE_DELETE_PROFILE_SUCCESS,
    CORE_DELETE_PROFILE_FAILURE,

    CORE_CREATE_PROFILE_REQUEST,
    CORE_CREATE_PROFILE_SUCCESS,
    CORE_CREATE_PROFILE_FAILURE,

    CORE_UPDATE_PROFILE_REQUEST,
    CORE_UPDATE_PROFILE_SUCCESS,
    CORE_UPDATE_PROFILE_FAILURE,

    //USER
    CORE_USER_VERIFY_REQUEST,
    CORE_USER_VERIFY_SUCCESS,
    CORE_USER_VERIFY_FAILURE,

    CORE_LOAD_ALL_USER_REQUEST,
    CORE_LOAD_ALL_USER_SUCCESS,
    CORE_LOAD_ALL_USER_FAILURE,

    CORE_LOAD_USER_REQUEST,
    CORE_LOAD_USER_SUCCESS,
    CORE_LOAD_USER_FAILURE,

    CORE_DELETE_USER_REQUEST,
    CORE_DELETE_USER_SUCCESS,
    CORE_DELETE_USER_FAILURE,

    CORE_CREATE_USER_REQUEST,
    CORE_CREATE_USER_SUCCESS,
    CORE_CREATE_USER_FAILURE,

    CORE_UPDATE_USER_REQUEST,
    CORE_UPDATE_USER_SUCCESS,
    CORE_UPDATE_USER_FAILURE,

    //VERSION
    CORE_LOAD_ALL_VERSION_REQUEST,
    CORE_LOAD_ALL_VERSION_SUCCESS,
    CORE_LOAD_ALL_VERSION_FAILURE,

    CORE_LOAD_VERSION_REQUEST,
    CORE_LOAD_VERSION_SUCCESS,
    CORE_LOAD_VERSION_FAILURE,

    CORE_DELETE_VERSION_REQUEST,
    CORE_DELETE_VERSION_SUCCESS,
    CORE_DELETE_VERSION_FAILURE,

    CORE_CREATE_VERSION_REQUEST,
    CORE_CREATE_VERSION_SUCCESS,
    CORE_CREATE_VERSION_FAILURE,

    CORE_UPDATE_VERSION_REQUEST,
    CORE_UPDATE_VERSION_SUCCESS,
    CORE_UPDATE_VERSION_FAILURE,

} from '../../types'

const initialState = {
    hasError: false,
    isLoading: false,
    errorMessage: '',
    errorCode: '',
    statusText: ''
}

export default (state = initialState, action) => {
    switch (action.type) {
        case CORE_LOAD_ALL_CONTACT_REQUEST:
        case CORE_LOAD_CONTACT_REQUEST:
        case CORE_DELETE_CONTACT_REQUEST:
        case CORE_CREATE_CONTACT_REQUEST:
        case CORE_UPDATE_CONTACT_REQUEST:
        case CORE_LOAD_ALL_CUSTOMER_REQUEST:
        case CORE_LOAD_CUSTOMER_REQUEST:
        case CORE_DELETE_CUSTOMER_REQUEST:
        case CORE_CREATE_CUSTOMER_REQUEST:
        case CORE_UPDATE_CUSTOMER_REQUEST:
        case CORE_LOAD_ALL_DEVICE_REQUEST:
        case CORE_LOAD_DEVICE_REQUEST:
        case CORE_DELETE_DEVICE_REQUEST:
        case CORE_CREATE_DEVICE_REQUEST:
        case CORE_UPDATE_DEVICE_REQUEST:
        case CORE_LOAD_ALL_IOTACCESSORY_REQUEST:
        case CORE_LOAD_IOTACCESSORY_REQUEST:
        case CORE_DELETE_IOTACCESSORY_REQUEST:
        case CORE_CREATE_IOTACCESSORY_REQUEST:
        case CORE_UPDATE_IOTACCESSORY_REQUEST:
        case CORE_LOAD_ALL_IOTROOM_REQUEST:
        case CORE_LOAD_IOTROOM_REQUEST:
        case CORE_DELETE_IOTROOM_REQUEST:
        case CORE_CREATE_IOTROOM_REQUEST:
        case CORE_UPDATE_IOTROOM_REQUEST:
        case CORE_UNREGISTER_IOTROOM_LICENSE_REQUEST:
        case CORE_LOAD_ALL_LICENSE_REQUEST:
        case CORE_LOAD_ALL_LICENSE_DISPLAY_REQUEST:
        case CORE_LOAD_ALL_LICENSE_IOT_REQUEST:
        case CORE_LOAD_LICENSE_REQUEST:
        case CORE_DELETE_LICENSE_REQUEST:
        case CORE_CREATE_LICENSE_REQUEST:
        case CORE_UPDATE_LICENSE_REQUEST:
        case CORE_LOAD_ALL_LICENSETYPE_REQUEST:
        case CORE_LOAD_LICENSETYPE_REQUEST:
        case CORE_LOAD_ALL_PRODUCT_REQUEST:
        case CORE_LOAD_PRODUCT_REQUEST:
        case CORE_DELETE_PRODUCT_REQUEST:
        case CORE_CREATE_PRODUCT_REQUEST:
        case CORE_UPDATE_PRODUCT_REQUEST:
        case CORE_UPVERSION_PRODUCT_REQUEST:
        case CORE_LOAD_ALL_PROFILE_REQUEST:
        case CORE_LOAD_PROFILE_REQUEST:
        case CORE_DELETE_PROFILE_REQUEST:
        case CORE_CREATE_PROFILE_REQUEST:
        case CORE_UPDATE_PROFILE_REQUEST:
        case CORE_USER_VERIFY_REQUEST:
        case CORE_LOAD_ALL_USER_REQUEST:
        case CORE_LOAD_USER_REQUEST:
        case CORE_DELETE_USER_REQUEST:
        case CORE_CREATE_USER_REQUEST:
        case CORE_UPDATE_USER_REQUEST:
        case CORE_LOAD_ALL_VERSION_REQUEST:
        case CORE_LOAD_VERSION_REQUEST:
        case CORE_DELETE_VERSION_REQUEST:
        case CORE_CREATE_VERSION_REQUEST:
        case CORE_UPDATE_VERSION_REQUEST:
            return {
                ...state,
                isLoading: true,
                hasError: false,
                errorMessage: '',
                errorCode: '',
                statusText: ''
            }
        case CORE_LOAD_ALL_CONTACT_SUCCESS:
        case CORE_LOAD_CONTACT_SUCCESS:
        case CORE_DELETE_CONTACT_SUCCESS:
        case CORE_CREATE_CONTACT_SUCCESS:
        case CORE_UPDATE_CONTACT_SUCCESS:
        case CORE_LOAD_ALL_CUSTOMER_SUCCESS:
        case CORE_LOAD_CUSTOMER_SUCCESS:
        case CORE_DELETE_CUSTOMER_SUCCESS:
        case CORE_CREATE_CUSTOMER_SUCCESS:
        case CORE_UPDATE_CUSTOMER_SUCCESS:
        case CORE_LOAD_ALL_DEVICE_SUCCESS:
        case CORE_LOAD_DEVICE_SUCCESS:
        case CORE_DELETE_DEVICE_SUCCESS:
        case CORE_CREATE_DEVICE_SUCCESS:
        case CORE_UPDATE_DEVICE_SUCCESS:
        case CORE_LOAD_ALL_IOTACCESSORY_SUCCESS:
        case CORE_LOAD_IOTACCESSORY_SUCCESS:
        case CORE_DELETE_IOTACCESSORY_SUCCESS:
        case CORE_CREATE_IOTACCESSORY_SUCCESS:
        case CORE_UPDATE_IOTACCESSORY_SUCCESS:
        case CORE_LOAD_ALL_IOTROOM_SUCCESS:
        case CORE_LOAD_IOTROOM_SUCCESS:
        case CORE_DELETE_IOTROOM_SUCCESS:
        case CORE_CREATE_IOTROOM_SUCCESS:
        case CORE_UPDATE_IOTROOM_SUCCESS:
        case CORE_UNREGISTER_IOTROOM_LICENSE_SUCCESS:
        case CORE_LOAD_ALL_LICENSE_SUCCESS:
        case CORE_LOAD_ALL_LICENSE_DISPLAY_SUCCESS:
        case CORE_LOAD_ALL_LICENSE_IOT_SUCCESS:
        case CORE_LOAD_LICENSE_SUCCESS:
        case CORE_DELETE_LICENSE_SUCCESS:
        case CORE_CREATE_LICENSE_SUCCESS:
        case CORE_UPDATE_LICENSE_SUCCESS:
        case CORE_LOAD_ALL_LICENSETYPE_SUCCESS:
        case CORE_LOAD_LICENSETYPE_SUCCESS:
        case CORE_LOAD_ALL_PRODUCT_SUCCESS:
        case CORE_LOAD_PRODUCT_SUCCESS:
        case CORE_DELETE_PRODUCT_SUCCESS:
        case CORE_CREATE_PRODUCT_SUCCESS:
        case CORE_UPDATE_PRODUCT_SUCCESS:
        case CORE_UPVERSION_PRODUCT_SUCCESS:
        case CORE_LOAD_ALL_PROFILE_SUCCESS:
        case CORE_LOAD_PROFILE_SUCCESS:
        case CORE_DELETE_PROFILE_SUCCESS:
        case CORE_CREATE_PROFILE_SUCCESS:
        case CORE_UPDATE_PROFILE_SUCCESS:
        case CORE_USER_VERIFY_SUCCESS:
        case CORE_LOAD_ALL_USER_SUCCESS:
        case CORE_LOAD_USER_SUCCESS:
        case CORE_DELETE_USER_SUCCESS:
        case CORE_CREATE_USER_SUCCESS:
        case CORE_UPDATE_USER_SUCCESS:
        case CORE_LOAD_ALL_VERSION_SUCCESS:
        case CORE_LOAD_VERSION_SUCCESS:
        case CORE_DELETE_VERSION_SUCCESS:
        case CORE_CREATE_VERSION_SUCCESS:
        case CORE_UPDATE_VERSION_SUCCESS:
            return {
                ...state,
                isLoading: false,
                // hasError: false,
                errorMessage: '',
                errorCode: '',
                statusText: ''
            }
        case CORE_LOAD_ALL_CONTACT_FAILURE:
        case CORE_LOAD_CONTACT_FAILURE:
        case CORE_DELETE_CONTACT_FAILURE:
        case CORE_CREATE_CONTACT_FAILURE:
        case CORE_UPDATE_CONTACT_FAILURE:
        case CORE_LOAD_ALL_CUSTOMER_FAILURE:
        case CORE_LOAD_CUSTOMER_FAILURE:
        case CORE_DELETE_CUSTOMER_FAILURE:
        case CORE_CREATE_CUSTOMER_FAILURE:
        case CORE_UPDATE_CUSTOMER_FAILURE:
        case CORE_LOAD_ALL_DEVICE_FAILURE:
        case CORE_LOAD_DEVICE_FAILURE:
        case CORE_DELETE_DEVICE_FAILURE:
        case CORE_CREATE_DEVICE_FAILURE:
        case CORE_UPDATE_DEVICE_FAILURE:
        case CORE_LOAD_ALL_IOTACCESSORY_FAILURE:
        case CORE_LOAD_IOTACCESSORY_FAILURE:
        case CORE_DELETE_IOTACCESSORY_FAILURE:
        case CORE_CREATE_IOTACCESSORY_FAILURE:
        case CORE_UPDATE_IOTACCESSORY_FAILURE:
        case CORE_LOAD_ALL_IOTROOM_FAILURE:
        case CORE_LOAD_IOTROOM_FAILURE:
        case CORE_DELETE_IOTROOM_FAILURE:
        case CORE_CREATE_IOTROOM_FAILURE:
        case CORE_UPDATE_IOTROOM_FAILURE:
        case CORE_UNREGISTER_IOTROOM_LICENSE_FAILURE:
        case CORE_LOAD_ALL_LICENSE_FAILURE:
        case CORE_LOAD_ALL_LICENSE_DISPLAY_FAILURE:
        case CORE_LOAD_ALL_LICENSE_IOT_FAILURE:
        case CORE_LOAD_LICENSE_FAILURE:
        case CORE_DELETE_LICENSE_FAILURE:
        case CORE_CREATE_LICENSE_FAILURE:
        case CORE_UPDATE_LICENSE_FAILURE:
        case CORE_LOAD_ALL_LICENSETYPE_FAILURE:
        case CORE_LOAD_LICENSETYPE_FAILURE:
        case CORE_LOAD_ALL_PRODUCT_FAILURE:
        case CORE_LOAD_PRODUCT_FAILURE:
        case CORE_DELETE_PRODUCT_FAILURE:
        case CORE_CREATE_PRODUCT_FAILURE:
        case CORE_UPDATE_PRODUCT_FAILURE:
        case CORE_UPVERSION_PRODUCT_FAILURE:
        case CORE_LOAD_ALL_PROFILE_FAILURE:
        case CORE_LOAD_PROFILE_FAILURE:
        case CORE_DELETE_PROFILE_FAILURE:
        case CORE_CREATE_PROFILE_FAILURE:
        case CORE_UPDATE_PROFILE_FAILURE:
        case CORE_USER_VERIFY_FAILURE:
        case CORE_LOAD_ALL_USER_FAILURE:
        case CORE_LOAD_USER_FAILURE:
        case CORE_DELETE_USER_FAILURE:
        case CORE_CREATE_USER_FAILURE:
        case CORE_UPDATE_USER_FAILURE:
        case CORE_LOAD_ALL_VERSION_FAILURE:
        case CORE_LOAD_VERSION_FAILURE:
        case CORE_DELETE_VERSION_FAILURE:
        case CORE_CREATE_VERSION_FAILURE:
        case CORE_UPDATE_VERSION_FAILURE:
            let returnData = {
                ...state,
                isLoading: false,
                hasError: true,
                error: action.payload
            }
            return returnData
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/features/ui/reducer.js